import { Swiper, SwiperSlide } from 'swiper/react';
import './styles.css';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import VenueCard from '../Common/VenueCard/VenueCard';

export default function VenueGallery({ venues }) {

  return (
    <>
      <div className='event-list'>
        <Swiper spaceBetween={25} slidesPerView={'auto'}>
          {venues?.map((item, x) => (
            <SwiperSlide key={`slide_${x}`}>
              <VenueCard venue={item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
}
